import type { ComponentTheme } from '../types/component-theme';
import { selectedCardShadowStyles } from '../shared-styles';

const selectedValueStyles = 'bg-(image:--accent-gradient) text-(--pure-white)! shadow-(--progress-glow-shadow-base)';

export default {
    slots: {
        root:
            'group relative flex w-full cursor-pointer items-start gap-3.5 rounded-[0.875rem] border border-solid ' +
            'border-(--slate-alpha-20) bg-(--glass-surface-bg-58) px-4 pt-4 pb-3.5 text-left ' +
            'transition-[border-color,background] duration-200 [backdrop-filter:blur(0.875rem)_saturate(160%)] ' +
            'hover:border-(--slate-alpha-30) hover:bg-(--selectable-card-hover-bg)',
        outerShadow:
            'pointer-events-none absolute inset-0 rounded-[inherit] shadow-(--estimate-row-shadow) transition-shadow ' +
            'duration-200 group-hover:shadow-(--selectable-card-hover-shadow)',
        value:
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-[0.75rem] bg-(--slate-alpha-12) ' +
            'font-(family-name:--primary-font) text-[1.125rem] text-(--text-dark) transition-shadow duration-200',
        content: 'min-w-0 flex-1',
        titleWrap: 'mb-[0.313rem] flex items-baseline gap-2',
        title: 'font-(family-name:--primary-font) text-[0.875rem] text-(--text-dark)',
        subtitle: 'font-(family-name:--secondary-font) text-[0.688rem] text-(--text-muted)',
        detail: 'm-0 font-(family-name:--secondary-font) text-[0.719rem] leading-[1.55] text-(--text-light)',
        meta: 'flex shrink-0 flex-col items-end gap-2 pt-0.5',
        check:
            'flex h-5.5 w-5.5 items-center justify-center rounded-full border-2 border-solid ' +
            'border-(--slate-alpha-30) text-transparent transition-[border-color,box-shadow] duration-200'
    },
    variants: {
        selected: {
            true: {
                root: 'bg-(--selectable-card-selected-bg)',
                outerShadow: selectedCardShadowStyles,
                value: selectedValueStyles,
                title: 'text-(--accent-solid)',
                check:
                    'border-transparent! bg-(image:--accent-gradient)! text-(--pure-white)! ' +
                    'shadow-(--progress-glow-shadow-sm)! [&>svg]:text-(--pure-white)! [&>svg]:fill-current! ' +
                    '[&>svg]:stroke-current!'
            }
        },
        disabled: {
            true: {
                root:
                    'cursor-not-allowed! border-(--slate-alpha-20) opacity-55 hover:border-(--slate-alpha-20) ' +
                    'hover:bg-(--glass-surface-bg-58)',
                outerShadow: 'shadow-(--estimate-row-shadow) group-hover:shadow-(--estimate-row-shadow)',
                value: 'bg-(--slate-alpha-08) text-(--text-muted)',
                title: 'text-(--text-muted)',
                subtitle: 'text-(--text-muted)',
                detail: 'text-(--text-muted)',
                check:
                    'border-(--selectable-card-disabled-border)! bg-transparent! text-(--text-muted)! shadow-none! ' +
                    'before:block before:h-0.5 before:w-3 before:-rotate-45 before:rounded-full before:bg-current ' +
                    'before:content-[""]'
            }
        }
    },
    compoundVariants: [
        {
            selected: true,
            disabled: true,
            class: {
                root: 'bg-(--selectable-card-selected-bg) opacity-100',
                value: selectedValueStyles,
                title: 'text-(--text-dark)',
                detail: 'text-(--text-light)'
            }
        }
    ]
} satisfies ComponentTheme;
